<template>
  <div v-if="activeVenue">
    <h3>Old lists</h3>
    <vs-tabs
      position="left"
      class="tabs-shadow-none mt-2"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <vs-tab
        v-if="
          hasPermissionForActiveVenue(
            'vp.vp.lists.venuevisits.show'
          )
        "
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Venue Visits' : ''"
      >
        <div class="lists-view-tab">
          <visits />
        </div>
      </vs-tab>
      <vs-tab
        v-if="
          hasPermissionForActiveVenue(
            'vp.vp.lists.maintenancereviews.show'
          )
        "
        icon-pack="feather"
        icon="icon-info"
        :label="!isSmallerScreen ? 'Maintenance Reviews' : ''"
      >
        <div class="lists-view-tab">
          <reviews />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import Visits from "./VenueVisits/Visits.vue";
import Reviews from "./MaintenanceReviews/Reviews.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Visits,
    Reviews,
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    // clickRoute(routeName) {
    //   this.$router.replace({ name: "lists", params: { listname: routeName } });
    // },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    // routeNameToIndex() {
    //   const name = this.$route.params.listname;
    //   console.log("ROUTE NAME", name);
    //   switch (name) {
    //     case "visits":
    //       return 0;
    //     case "eodreports":
    //       return 1;
    //     default:
    //       return 0;
    //   }
    // },
  },
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
